"use client";

import { createContext } from "react";

type Navigate = (href: string) => void;

// Holds the navigation that lets the all-games section show its loading
// state. `null` outside the section, where navigating needs no pending UI.
const AllGamesNavigationContext = createContext<Navigate | null>(null);

export default AllGamesNavigationContext;
